<template>
  <v-dialog v-model="dialog" max-width="1200px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Order.ImportOrderErr.title") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-data-table
                :headers="headers"
                :items="errorOrders"
                multi-sort
                class="elevation-1 px-4 pt-2"
                disable-pagination
                hide-default-footer
                fixed-header
        >
          <template v-slot:item.index="{ index }">
            <span>
              {{ index + 1 }}
            </span>
          </template>
          <template v-slot:item.ext_code="{ item }">
            <span class="red--text" v-if="Object.keys(item.errors).includes('ext_code')">
              {{ item.errors.ext_code }}
            </span>
            <span v-else>
              {{ item.ext_code }}
            </span>
          </template>
          <template v-slot:item.actual_date="{ item }">
            <span class="red--text" v-if="Object.keys(item.errors).includes('actual_date')">
              {{ item.errors.actual_date }}
            </span>
            <span v-else>
              {{ item.actual_date }}
            </span>
          </template>
          <template v-slot:item.shop_code="{ item }">
            <span class="red--text" v-if="Object.keys(item.errors).includes('shop_code')">
              {{ item.errors.shop_code }}
            </span>
            <span v-else>
              {{ item.shop_code }}
            </span>
          </template>
          <template v-slot:item.material_code="{ item }">
            <span class="red--text" v-if="Object.keys(item.errors).includes('material_code')">
              {{ item.errors.material_code }}
            </span>
            <span v-else>
              {{ item.material_code }}
            </span>
          </template>
          <template v-slot:item.material_name="{ item }">
            <span class="red--text" v-if="Object.keys(item.errors).includes('material_name')">
              {{ item.errors.material_name }}
            </span>
            <span v-else>
              {{ item.material_name }}
            </span>
          </template>
          <template v-slot:item.apply_num="{ item }">
            <span class="red--text" v-if="Object.keys(item.errors).includes('apply_num')">
              {{ item.errors.apply_num }}
            </span>
            <span v-else>
              {{ item.apply_num }}
            </span>
          </template>
          <template v-slot:item.price="{ item }">
            <span class="red--text" v-if="Object.keys(item.errors).includes('price')">
              {{ item.errors.price }}
            </span>
            <span v-else>
              {{ item.price }}
            </span>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import {mapState} from "vuex";
import i18n from "@/i18n";

export default {
  name: "ImportOrdersResultDialog",

  props: {
    value: Boolean,
    errorOrders: Array
  },
  computed: {
    headers: () => [
      {
        text: i18n.t("Order.ImportOrderErr.importResult.no"),
        align: "start",
        sortable: false,
        value: "index",
      },
      {
        text: i18n.t("Order.ImportOrderErr.importResult.ext_code"),
        align: "start",
        sortable: false,
        value: "ext_code",
      },
      {
        text: i18n.t("Order.ImportOrderErr.importResult.actual_date"),
        align: "start",
        sortable: false,
        value: "actual_date",
      },
      {
        text: i18n.t("Order.ImportOrderErr.importResult.shop_code"),
        align: "start",
        sortable: false,
        value: "shop_code",
      },
      {
        text: i18n.t("Order.ImportOrderErr.importResult.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("Order.ImportOrderErr.importResult.material_name"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("Order.ImportOrderErr.importResult.apply_num"),
        align: "start",
        sortable: false,
        value: "apply_num",
      },
      {
        text: i18n.t("Order.ImportOrderErr.importResult.price"),
        align: "start",
        sortable: false,
        value: "price",
      }
    ],
    ...mapState(["loading"]),
  },
  data: () => ({
    dialog: false,
  }),
  methods: {

  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>